import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";
import { Organization } from "../../types/organization";
import { BillingLedgerEntry } from "./BillingClient";

class OrganizationClient {
  private auth0Client: Auth0Client;

  private providerServiceBase = import.meta.env.VITE_PROVIDER_SERVICE_BASE;

  constructor(auth0Client: Auth0Client) {
    this.auth0Client = auth0Client;
  }

  private async getAuthHeaders() {
    const token = await this.auth0Client.getTokenSilently();
    return { Authorization: `Bearer ${token}` };
  }

  /** Get organization by Auth0 org id (org_...). Uses plain /organizations/auth/:id. */
  async getOrganization(orgId: string): Promise<Organization> {
    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${this.providerServiceBase}/organizations/auth/${orgId}`,
      {
        headers,
      },
    );
    return response.data;
  }

  /** Get organization by any id (ObjectId, UUID, or auth0 id). Uses plain /organizations/:id. */
  async getOrganizationById(orgId: string): Promise<Organization> {
    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${this.providerServiceBase}/organizations/${orgId}`,
      {
        headers,
      },
    );
    return response.data;
  }

  /** List all organizations. Uses plain /organizations. */
  async listOrganizations(): Promise<Organization[]> {
    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${this.providerServiceBase}/organizations`,
      { headers },
    );
    return response.data;
  }

  async getBillingLedger(orgId: string): Promise<BillingLedgerEntry[]> {
    const headers = await this.getAuthHeaders();
    const response = await axios.get(
      `${this.providerServiceBase}/v2/api/billing-ledger/org/${orgId}/current`,
      { headers },
    );
    return response.data;
  }
}

export default OrganizationClient;
